import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

export default function Gleam({ item }) {
  const embedUrl = get(item, 'embed.embed_url', get(item, 'embed_link'));

  if (!embedUrl) return false;

  return (<iframe
    scrolling="yes"
    frameBorder="0"
    src={embedUrl}
    width="100%"
    height="1400"
    loading="lazy"
  />);
}

Gleam.propTypes = {
  item: PropTypes.shape({}).isRequired,
};
